import type { FC } from "react";

import { MerchantProductsActivityPanel } from "@src/components";

type ProductsPageProps = object;

export const ProductsActivityPanelPage: FC<ProductsPageProps> = () => {
    return (
        <div className="flex h-full w-full items-stretch">
            <MerchantProductsActivityPanel />
        </div>
    );
};
